module.exports = __webpack_public_path__ + "img/WellnessHeader.b00cff05.jpg";